import { apiClient } from './client';
import type { TrainingProgram, CreateTrainingProgramRequest } from '../types/api';
import type { ParsedTrainingBlock } from './trainingBlockApi';

export interface ParsedTrainingProgram {
  name: string;
  tags?: string[];
  days: ParsedTrainingBlock[];
}

export interface ParseProgramResponse {
  sessionId: string;
  result: ParsedTrainingProgram;
}

export const trainingProgramApi = {
  async getPrograms(): Promise<TrainingProgram[]> {
    return apiClient.get<TrainingProgram[]>('/v1/training-programs');
  },

  async getProgram(id: number): Promise<TrainingProgram> {
    return apiClient.get<TrainingProgram>(`/v1/training-programs/${id}`);
  },

  async createProgram(request: CreateTrainingProgramRequest): Promise<TrainingProgram> {
    return apiClient.post<TrainingProgram>('/v1/training-programs', request);
  },

  async updateProgram(id: number, request: CreateTrainingProgramRequest): Promise<TrainingProgram> {
    return apiClient.put<TrainingProgram>(`/v1/training-programs/${id}`, request);
  },

  async deleteProgram(id: number): Promise<void> {
    return apiClient.delete<void>(`/v1/training-programs/${id}`);
  },

  async saveProgram(id: number): Promise<TrainingProgram> {
    return apiClient.post<TrainingProgram>(`/v1/training-programs/${id}/save`);
  },

  async parseProgram(rawText: string): Promise<ParseProgramResponse> {
    return apiClient.post<ParseProgramResponse>('/v1/training-programs/parse', { rawText });
  },

  async reparseProgram(
    sessionId: string,
    currentProgram: ParsedTrainingProgram,
    comment: string
  ): Promise<ParseProgramResponse> {
    return apiClient.post<ParseProgramResponse>('/v1/training-programs/reparse', {
      sessionId,
      currentProgram,
      comment,
    });
  },
};
